import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from "./context/AuthContext";
import { ConversationsContext } from "./context/ConversationsContext";
import { ActivityContext } from "./context/ActivityContext";
import { HistoryContext } from "./context/HistoryContext";
import { ProsContext } from "./context/ProsContext";
import { updateLuxMetiersVariables } from "./utils/luxVariables";
import Sidebar from './components/Sidebar';
import ExpertChatPage from './pages/ExpertChatPage';
import ActivityChatPage from './pages/ActivityChatPage';
import JobsList from './pages/JobsList';
import Job from './pages/Job';
import Dip from './pages/Dip';
import JobDetail from './pages/JobDetail';
import AuthForm from './pages/AuthForm';
import ResetPassword from './pages/ResetPassword';
import JobProDesk from './pages/JobProDesk';
import ParentCoachLanding from './pages/ParentCoachLanding';
import Privacy from './pages/Privacy';
import QuizValeurs from './pages/QuizValeurs';
import QuizRiasec from './pages/QuizRiasec';
import QuizJourda from './pages/QuizJourda';
import QuizIM from './pages/QuizIM';
import DifyChatPage from './pages/DifyChatPage';
import Onboarding from './pages/Onboarding';
import MonEspace from './pages/MonEspace';
import TivPage from './pages/TivPage';
import TivChatPage from './pages/TivChatPage';
import TivLetterPage from './pages/TivLetterPage';

function App() {
  const { initSessionActivity } = useContext(ActivityContext);
  const { addAction } = useContext(HistoryContext);
  const { initSession } = useContext(ConversationsContext);
  const { itemsPro } = useContext(ProsContext);
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useContext(AuthContext);

  async function handleCreateItem(values) {
    const history = await addAction({type: "EXPERT_CHAT_STARTED", values})
    await initSession(history, values, process.env.REACT_APP_VF_API_KEY)
    await updateLuxMetiersVariables(user.id, history, itemsPro)
    console.log("JOB EXPERT SESSION INITED")
    return `/pro/${values.id}/${values.gender}/chat`;
  };

  async function initActivity(values) {
    const api_key = values.type === 'grit-and-fit' ? process.env.REACT_APP_VF_GRITANDFIT_API_KEY : process.env.REACT_APP_VF_QUIZZ_API_KEY
    let type = "QUIZZ_STARTED"
    if ( values.type === 'grit-and-fit' )
      type = "GRIT_AND_FIT_STARTED"
    await addAction({type, values})
    await initSessionActivity(values,  api_key)
    console.log(`JOB ${values.type} SESSION INITED`)
    return `/pro/${values.jobId}/${values.gender}/${values.type}`;
  };

  // Onboarding plein écran (sans sidebar)
  if (user && !user.onboarding_completed) {
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="*" element={<Navigate to="/onboarding" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/offre-de-lancement" element={<ParentCoachLanding />} />
        <Route path="/politique-de-confidentialite" element={<Privacy />} />
        <Route path="*" element={
          <div className="flex h-dvh bg-gray-900 text-white">
            {user && <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />}
            <Routes>
              {user !== null ? (
                <>
                  <Route path="/" element={<Navigate to="/mon-espace" replace />} />
                  <Route path="/onboarding" element={<Navigate to="/mon-espace" replace />} />
                  <Route path="/pro/:chatId/:gender/chat" element={<ExpertChatPage onSend={handleCreateItem} />} />
                  <Route path="/chat/:chatId" element={<ExpertChatPage onSend={handleCreateItem} />} />
                  <Route path="/pro/:jobId/:gender" element={<JobProDesk initActivity={initActivity} handleCreateItem={handleCreateItem} />} />
                  <Route path="/pro/:jobId/:gender/:type" element={<ActivityChatPage />} />
                  <Route path="/metiers" element={<JobsList onSend={handleCreateItem} />} />
                  <Route path="/job" element={<Job onSend={handleCreateItem} initActivity={initActivity} />} />
                  <Route path="/dip" element={<Dip />} />
                  <Route path="/metiers/:jobId/:gender" element={<JobDetail onSend={handleCreateItem} initActivity={initActivity} />} />
                  <Route path="/mon-espace" element={<MonEspace />} />
                  <Route path="/tiv" element={<TivPage />} />
                  <Route path="/tiv/lettre-motivation/:id" element={<TivChatPage />} />
                  <Route path="/tiv/lettre-motivation/:id/detail" element={<TivLetterPage />} />
                  <Route path="/questionnaires/mes-valeurs" element={<QuizValeurs />} />
                  <Route path="/questionnaires/mes-interets" element={<QuizRiasec />} />
                  <Route path="/questionnaires/mes-energies" element={<QuizJourda />} />
                  <Route path="/questionnaires/mes-intelligences" element={<QuizIM />} />
                  <Route path="/chat/v2/:botId" element={<DifyChatPage />} />
                </>
              ) : (
                <>
                  <Route path="/auth" element={<AuthForm />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="*" element={<Navigate to="/auth" replace />} />
                </>
              )}
            </Routes>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;